import ApiService from './api.service'


const ClientService = {

	getAllClient: (data) => {
		return ApiService.post(`customer/search`, data);
	},
	getOneClient: (clientId) => {
		return ApiService.get(`customer/get/${clientId}`);
	},
	searchLastName: (data) => {
		return ApiService.post(`/customer/list-search/${data}`, data);
	},

	searchMember: function (memberCard) {
		return ApiService.post(`customer/scanner/${memberCard}`, memberCard)
	},
	saveClient: function (newClient) {
		return ApiService.post(`/customer/add-or-update`, newClient);
	},
	deleteCLient: function (customerId) {
		return ApiService.delete(`/customer/delete/${customerId}`);
	},
	generateMemberCard: function () {
		return ApiService.get(`customer/generate-member`);
	},
	discountForCard: function (clientDiscountArray) {
		return ApiService.post(`/discount-type/create`, clientDiscountArray);
	},
	listDiscountForCard: function () {
		return ApiService.get(`/discount-type/list`)
	},
	deleteDiscountForCard:function (item) {
	return ApiService.delete(`/discount-type/delete/${item.id}`)
	},

	getExpiredItems(data) {
		return ApiService.post(`/item-balance/search/expired-items`, data)
	}


}
export default ClientService
